import videoOne from './HomeContent/video.mp4'
import videoTwo from './HomeContent/videoTwo.mp4'
import videoThree from './HomeContent/videoThree.mp4'

export const slider = [
{
    id: 1,
    video: videoOne
},

    {
        id: 2,
        video: videoTwo
    },

        {
            id: 3,
            video: videoThree
        }
        
]